module.exports = __webpack_public_path__ + "static/media/lightblades-installation-by-lucastswick-clouds-2.abeeb31a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lightblades/lightblades-installation-by-lucastswick-clouds-2.jpg
// module id = 4254
// module chunks = 15